import { ref, computed } from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { TIMER_ACTION } from '../Utils/vice-constants';

dayjs.extend(duration);

/**
 * A Composable to get countdown and count-up timer
 * @param {*} startTimeInMilliSeconds - timer start in milliseconds
 * @param {*} type - whether to countdown or count up
 * @returns
 */

function useTimer(startTimeInMilliSeconds, action) {
  const timerRef = ref(null);
  const sessionDuration = ref(startTimeInMilliSeconds);
  const prettifyNumber = (theNumber) =>
    theNumber.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });

  const formatedDuration = computed(() => {
    const seconds = dayjs.duration(sessionDuration.value).seconds();
    const minutes = dayjs.duration(sessionDuration.value).minutes();
    return `${prettifyNumber(minutes)}:${prettifyNumber(seconds)}`;
  });

  const startTimer = () => {
    timerRef.value = setInterval(() => {
      if (action === TIMER_ACTION.INCREASE) {
        sessionDuration.value += 1000;
      }

      if (action === TIMER_ACTION.DECREASE) {
        sessionDuration.value -= 1000;
      }
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.value);
    timerRef.value = null;
  };

  return {
    stopTimer,
    startTimer,
    formatedDuration,
    rawTimeLeft: sessionDuration,
  };
}

export default useTimer;
